import { useMutation } from "react-query";
import { put } from "shared/data";

export const useUpdateClientSla = () => {
    return useMutation("updateClientSla", {
        mutationFn: (payload) => put("/sla/client", payload),
    });
};
